import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { Paragraph } from '@sovryn/ui';
import { TransferForm } from './components/TransferForm/TransferForm';
import { Tabs } from '@sovryn/ui';
import { TabSize } from '@sovryn/ui';
import { TabType } from '@sovryn/ui';
import styles from './TransferPage.module.css';
import { TransactionHistory } from 'components/TransactionHistory/TransactionHistory';
import classNames from 'classnames';
import desktopImage from 'assets/images/globe_desktop.svg';
import mobileImage from 'assets/images/globe_mobile.svg';
import { CaptchaVerification } from 'components/CaptchaVerification/CaptchaVerification';
import { useAccount as useSatsAccount } from '@gobob/sats-wagmi';
import { noop } from '@sovryn/ui';
export const TransferPage = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { address: btcWalletAddress } = useSatsAccount();
    const tabs = useMemo(() => [
        {
            label: _jsx("div", { className: "text-sm", children: "Transfer" }),
            content: _jsx(TransferForm, {}),
            activeClassName: 'text-primary-20',
        },
        {
            label: _jsx("div", { className: "text-sm", children: "History" }),
            content: _jsx(TransactionHistory, {}),
            activeClassName: 'text-primary-20',
        },
    ], []);
    return (_jsxs("div", { className: "mx-auto py-5 px-6", children: [_jsxs("div", { className: "flex items-center justify-center mb-6", children: [_jsx(Paragraph, { className: "text-white font-semibold text-center leading-9 w-[15.75rem] mb-6", children: _jsxs(_Fragment, { children: [_jsx("span", { className: classNames('text-3xl sm:text-[2.5rem] leading-[1.25] text-left block', styles.highlight), children: "Grail" }), _jsxs("span", { className: "text-2xl leading-[1.15] text-left block", children: ["Truly Trustless", _jsx("br", {}), " Bitcoin Bridge"] })] }) }), _jsx("img", { src: desktopImage, alt: "BitcoinOS", className: "hidden sm:block" }), _jsx("img", { src: mobileImage, alt: "BitcoinOS", className: "block sm:hidden" })] }), _jsx(CaptchaVerification, { btcAddress: btcWalletAddress, onVerified: () => console.log('CAPTCHA verification completed'), onError: noop }), _jsx(Tabs, { items: tabs, index: activeTabIndex, onChange: setActiveTabIndex, size: TabSize.normal, type: TabType.secondary, contentClassName: "bg-transparent mt-2 w-full", className: styles.tabs })] }));
};
